/**
 * Adds a notary application.
 *
 * @param {Object} application - The person data for the application.
 */
export async function addApplication(application: Object) {
  return fetch('/applications/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(application)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Adds a notary application.
 *
 * @param {Object} application - The person data for the application.
 */
export async function addChangeApplication(application: Object) {
  return fetch('/requests/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(application)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Approves a notary application.
 *
 * @param {Object} application - The person data for the application.
 */
export async function approveApplication(application: Object) {
  return fetch('/applications/', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(application)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Gets a notary application.
 *
 * @param {string} uuid - the uuid of the application.
 */
export async function getApplicationByUuid(uuid: string) {
  return fetch('/registration/uuid/' + uuid, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }
      return null;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

/**
 * Gets notary applications.
 *
 * @param {number} stateNotaryId - the uuid of the application.
 */
export async function getApplications(stateNotaryId: number) {
  return fetch('/applications/state-notary-id/' + stateNotaryId, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return response.json();
  });
}

/**
 * Uploads a signed file for the application.
 *
 * @param {File} file - The file to upload.
 * @param {string} uuid - The application uuid.
 */
export async function addSignedDocument(file: File, uuid: string) {
  const data = new FormData();
  data.append('file', file);
  return fetch('/registration/signed-document/' + uuid, {
    method: 'POST',
    body: data
  }).then((response) => {
    return response.json();
  });
}
